import { theme } from "../../config/theme";

const drawerWidth = 256;

const styles = {
  root: {
    display: "flex",
    minHeight: "100vh",
    background: "#eaeff1"
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  app: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  main: {
    flex: 1,
    background: "#eaeff1"
  },
  footer: {
    padding: theme.spacing(2),
    background: "#eaeff1"
  }
};

export { drawerWidth, styles };
